import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminLayout from '../layout/admin/AdminLayout'
import SchoolLayout from '../layout/school/SchoolLayout'
import SchoolLayoutDataCenter from '../layout/school/SchoolLayoutDataCenter'
import TeacherLayout from '../layout/teacher/TeacherLayout'
import TeacherCourseLayout from '../layout/teacher/TeacherCourseLayout'
import TeacherDataCenterLayout from '../layout/teacher/TeacherDataCenterLayout'
import JudgesLayout from '../layout/judges/JudgesLayout'
import studentTrainingLayout from '../layout/student/studentTrainingLayout'
import studentExamLayout from '../layout/student/studentExamLayout'
import studentCourseLayout from "../layout/student/studentCourseLayout";
import Main from '../layout/Main'
import ExamDataLayout from '../layout/teacher/ExamDataLayout'
import TrainDataLayout from '../layout/teacher/TrainDataLayout'
import GoodsInfoLayout from '../layout/student/GoodsInfoLayout'
import GoodsShopLayout from '../layout/student/GoodsShopLayout'
import OrderLayout from '../layout/student/OrderLayout'
import JudgesTypeLayout from '../layout/judges/JudgesTypeLayout'
import CertificateLayout from '../layout/teacher/CertificateLayout'
//课程那边的重复跳转报错处理
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

export const LoginRoutes = [
    {
        path: '/',
        name: 'login',
        component: () => import('../views/Login.vue'),
        meta: {
            // title: '1+X电子商务客户服务平台',
            title: '1+X短视频数据分析仿真平台',
            role: 1
        }
    },
    {
        path: '/upload',
        name: 'upload',
        component: () => import('../views/Upload.vue'),
        meta: {
            title: '分片上传demo',
            role: 1,
        }
    },
    {
        path: '/goods/detail',
        name: 'goodsDetail',
        component: () => import('../views/goodsDetail/goodsDetail.vue'),
        meta: {
            title: '商品详情',
            role: 5,
        }
    },
    {
        path: '/chat',
        name: 'chat',
        component: () => import('../views/student/chat/Index.vue'),
        meta: {
            title: '在线对话',
            role: 5,
        }
    },

]

// export const commonRoutes = []

export const adminRoutes = [
    {
        path: '/admin',
        name: 'admin',
        redirect: '/educational/school',
        component: AdminLayout,
        children: [
            {
                path: '/educational',
                name: 'educational',
                redirect: '/educational/school',
                component: Main,
                meta: {
                    title: '教务管理',
                    icon: '&#xe6b4;',
                    role: 1
                },
                children: [
                    {
                        path: '/educational/school',
                        name: 'educationalSchool',
                        component: () => import('../views/admin/educationalManage/Index.vue'),
                        meta: {
                            title: '学校管理',
                            role: 1,
                            parentName: ['educational']
                        },
                    },
                    {
                        path: '/educational/schoolAdministrator',
                        name: 'educationalSchoolAdministrator',
                        component: () => import('../views/admin/educationalManage/SchoolAdministrator.vue'),
                        meta: {
                            title: '学校管理员',
                            role: 1,
                            parentName: ['educational']
                        },
                    },
                ]
            },
            {
                path: '/classification',
                name: 'classification',
                redirect: '/classification/index',
                component: Main,
                meta: {
                    title: '分类管理',
                    icon: '&#xe6ae;',
                    role: 1
                },
                children: [
                    {
                        path: '/classification/index',
                        name: 'classificationIndex',
                        component: () => import('../views/admin/classificationManage/Index.vue'),
                        meta: {
                            title: '课程管理',
                            role: 1,
                            parentName: ['classification']
                        },
                    },
                    {
                        path: '/classification/resources',
                        name: 'classificationResources',
                        component: () => import('../views/admin/classificationManage/Resources.vue'),
                        meta: {
                            title: '资源库分类',
                            role: 1,
                            parentName: ['classification']
                        },
                    },
                    {
                        path: '/classification/questions',
                        name: 'classificationQuestions',
                        component: () => import('../views/admin/classificationManage/Questions.vue'),
                        meta: {
                            title: '试题库分类',
                            role: 1,
                            parentName: ['classification']
                        },
                    },
                ]
            },
            {
                path: '/label',
                name: 'label',
                redirect: '/label/index',
                component: Main,
                meta: {
                    title: '标签管理',
                    icon: '&#xe6ad;',
                    role: 1
                },
                children: [
                    {
                        path: '/label/index',
                        name: 'labelIndex',
                        component: () => import('../views/admin/labelManage/Index.vue'),
                        meta: {
                            title: '标签管理',
                            role: 1,
                            parentName: ['label'],
                            level: 2,

                            hidden: true
                        },
                    },
                    {
                        path: '/label/resources',
                        name: 'labelResources',
                        component: () => import('../views/admin/labelManage/Resources.vue'),
                        meta: {
                            title: '资源库',
                            role: 1,
                            parentName: ['label'],
                            hidden: true
                        },
                    },
                    {
                        path: '/label/questions',
                        name: 'labelQuestions',
                        component: () => import('../views/admin/labelManage/Questions.vue'),
                        meta: {
                            title: '试题库',
                            role: 1,
                            parentName: ['label'],
                            hidden: true
                        },
                    },
                ]
            },
            {
                path: '/resources',
                name: 'resources',
                redirect: '/resources/index',
                component: Main,
                meta: {
                    title: '资源库',
                    icon: '&#xe63f;',
                    role: 1
                },
                children: [
                    {
                        path: '/resources/index',
                        name: 'resourcesIndex',
                        component: () => import('../views/admin/resourcesLibrary/Index.vue'),
                        meta: {
                            title: '资源库',
                            role: 1,
                            parentName: ['resources'],
                            hidden: true
                        },
                    },
                ]
            },
            {
                path: '/theory',
                name: 'theory',
                redirect: '/theory/index',
                component: Main,
                meta: {
                    title: '理论题',
                    icon: '&#xe6b2;',
                    role: 1
                },
                children: [
                    {
                        path: '/theory/index',
                        name: 'theoryIndex',
                        component: () => import('../views/admin/theoryQuestions/Index.vue'),
                        meta: {
                            title: '理论题',
                            role: 1,
                            parentName: ['theory']
                        },
                    },
                    {
                        path: '/theory/add',
                        name: 'theoryAdd',
                        component: () => import('../views/admin/theoryQuestions/AddQuestion'),
                        meta: {
                            title: '添加试题',
                            role: 1,
                            parentName: ['theory', 'theoryIndex'],
                            hidden: true,
                            level: 2
                        },
                    },
                    {
                        path: '/theory/questions',
                        name: 'theoryQuestions',
                        component: () => import('../views/admin/theoryQuestions/Questions.vue'),
                        meta: {
                            title: '试卷管理',
                            role: 1,
                            parentName: ['theory']
                        },
                    },
                    {
                        path:'/theory/questions/add',
                        name:'theoryQuestionsAdd',
                        component: () => import('../views/admin/theoryQuestions/TheoryQuestionsAdd.vue'),
                        meta: {
                            title: '添加试卷',
                            role: 1,
                            parentName: ['theory', 'theoryQuestions'],
                            hidden: true,
                            level: 2
                        }
                    },
                ]
            },
            {
                path: '/practice',
                name: 'practice',
                redirect: '/practice/index',
                component: Main,
                meta: {
                    title: '实操题',
                    icon: '&#xe6b2;',
                    role: 1
                },
                children: [
                    {
                        path: '/practice/index',
                        name: 'practiceIndex',
                        component: () => import('../views/admin/practiceQuestions/Index.vue'),
                        meta: {
                            title: '实操题',
                            role: 1,
                            parentName: ['practice']
                        },
                    },
                    {
                        path: '/practice/goods',
                        name: 'practiceGoods',
                        component: () => import('../views/admin/practiceQuestions/Goods.vue'),
                        meta: {
                            title: '商品',
                            role: 1,
                            parentName: ['practice']
                        },
                    },
                    {
                        path: '/practice/goodsCategory',
                        name: 'practiceGoodsCategory',
                        component: () => import('../components/admin/practicalExercises/goods/GoodsCategory'),
                        meta: {
                            title: '选择分类',
                            role: 1,
                            parentName: ['practice', 'practiceGoods'],
                            hidden: true,
                            level: 2
                        },
                    },
                    {
                        path: '/practice/goodsAdd',
                        name: 'practiceGoodsAdd',
                        component: () => import('../components/admin/practicalExercises/goods/GoodsAdd'),
                        meta: {
                            title: '添加商品',
                            role: 1,
                            parentName: ['practice', 'practiceGoods'],
                            hidden: true,
                            level: 2
                        },
                    },
                    // {
                    //     path: '/practice/hotKeywords',
                    //     name: 'practiceHotKeywords',
                    //     component: () => import('../views/admin/practiceQuestions/HotKeywords.vue'),
                    //     meta: {
                    //         title: '热门关键词',
                    //         role: 1,
                    //         parentName: ['practice']
                    //     },
                    // },
                    {
                        path: '/practice/hotKeywords/create',
                        name: 'practiceHotKeywordsCreate',
                        component: () => import('../views/admin/practiceQuestions/HotKeywordsCreate.vue'),
                        meta: {
                            title: '添加关键词',
                            role: 1,
                            parentName: ['practice','practiceHotKeywords'],
                            hidden: true,
                            level: 2,
                        },
                    },
                    {
                        path: '/practice/customerServiceManagement',
                        name: 'practiceCustomerServiceManagement',
                        component: () => import('../views/admin/practiceQuestions/CustomerServiceManagement.vue'),
                        meta: {
                            title: '客服管理',
                            role: 1,
                            parentName: ['practice']
                        },
                    },
                    {
                        path:'/practice/addCustomerServiceManagement',
                        name:'practiceAddCustomerServiceManagement',
                        component: () => import('../views/admin/practiceQuestions/AddCustomerServiceManagement.vue'),
                        meta: {
                            title: '添加客服数据',
                            role: 1,
                            parentName: ['practice', 'practiceCustomerServiceManagement'],
                            hidden: true,
                            level: 2,
                        }
                    },
                    // {
                    //     path: '/practice/customerInformation',
                    //     name: 'practiceCustomerInformation',
                    //     component: () => import('../views/admin/practiceQuestions/CustomerInformation.vue'),
                    //     meta: {
                    //         title: '客户信息',
                    //         role: 1,
                    //         parentName: ['practice']
                    //     },
                    // },
                    {
                        path: '/practice/addCustomerInformation',
                        name: 'practiceAddCustomerInformation',
                        component: () => import('../views/admin/practiceQuestions/AddCustomerInformation.vue'),
                        meta: {
                            title: '添加客户信息',
                            role: 1,
                            parentName: ['practice'],
                            hidden: true,
                            level:2,
                        },
                    },
                    // {
                    //     path: '/practice/paperManagement',
                    //     name: 'practicePaperManagement',
                    //     component: () => import('../views/admin/practiceQuestions/PaperManagement.vue'),
                    //     meta: {
                    //         title: '试卷管理',
                    //         role: 1,
                    //         parentName: ['practice']
                    //     },
                    // },
                    {
                        path:'/practice/paperAddManagement',
                        name: 'practiceAddPaperManagement',
                        component: () => import('../views/admin/practiceQuestions/AddPaperManagement.vue'),
                        meta: {
                            title: '添加试卷',
                            role: 1,
                            parentName: ['practice', 'practicePaperManagement'],
                            hidden: true,
                            level:2,
                        }
                    },
                    {
                        path: '/practice/create',
                        name: 'practiceCreate',
                        component: () => import('../views/admin/practiceQuestions/PracticeCreate.vue'),
                        meta: {
                            title: '添加试题',
                            role: 1,
                            parentName: ['practice','practiceIndex'],
                            hidden: true,
                            level: 2,
                        },
                    },
                ]
            },
            {
                path: '/paper',
                name: 'paper',
                redirect: '/paper/index',
                component: Main,
                meta: {
                    title: '试卷管理',
                    icon: '&#xe6b3;',
                    role: 1
                },
                children: [
                    {
                        path: '/paper/index',
                        name: 'paperIndex',
                        component: () => import('../views/admin/paperManage/Index.vue'),
                        meta: {
                            title: '试卷管理',
                            role: 1,
                            parentName: ['paper'],
                            hidden: true,
                        },
                    },
                    {
                        path:'/paper/addPaperTemplate',
                        name:'addPaperTemplate',
                        component: () => import('../views/admin/paperManage/AddPaperTemplate.vue'),
                        meta: {
                            title: '创建试卷模板',
                            role: 1,
                            parentName:['paper', 'paperIndex'],
                            hidden: true,
                            level: 2
                        }
                    }
                ]
            },
            {
                path: '/course',
                name: 'course',
                redirect: '/course/index',
                component: Main,
                meta: {
                    title: '课程管理',
                    icon: '&#xe6af;',
                    role: 1
                },
                children: [
                    {
                        path: '/course/index',
                        name: 'courseIndex',
                        component: () => import('../views/admin/courseManage/Index.vue'),
                        meta: {
                            title: '课程管理',
                            role: 1,
                            parentName: ['course'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/course/create',
                        name: 'courseCreate',
                        component: () => import('../views/admin/courseManage/courseCreate.vue'),
                        meta: {
                            title: '创建课程',
                            role: 1,
                            parentName: ['course','courseIndex'],
                            hidden: true,
                            level:2,
                        },
                    },
                ]
            },
            {
                path: '/paperProbability',
                name: 'paperProbability',
                redirect: '/paperProbability/index',
                component: Main,
                meta: {
                    title: '组卷概率',
                    icon: '&#xe6b0;',
                    role: 1
                },
                children: [
                    {
                        path: '/paperProbability/index',
                        name: 'paperProbabilityIndex',
                        component: () => import('../views/admin/paperProbability/Index.vue'),
                        meta: {
                            title: '组卷概率',
                            role: 1,
                            parentName: ['paperProbability'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/paperProbability/create',
                        name: 'paperProbabilityCreate',
                        component: () => import('../views/admin/paperProbability/paperCreate.vue'),
                        meta: {
                            title: '创建概率模板',
                            role: 1,
                            parentName: ['paperProbability','paperProbabilityIndex'],
                            hidden: true,
                            level:2,
                        },
                    },
                ]
            }
        ]
    },
]

export const schoolRoutes = [
    {
        path: '/school',
        name: 'school',
        redirect: '/school/educational/teacher',
        component: SchoolLayout,
        children: [
            {
                path: '/school/educational',
                name: 'schoolEducational',
                redirect: '/school/educational/teacher',
                component: Main,
                meta: {
                    title: '教务管理',
                    icon: '&#xe6b4;',
                    role: 2
                },
                children: [
                    {
                        path: '/school/educational/teacher',
                        name: 'educationalTeacher',
                        component: () => import('../views/school/educationalManage/TeacherManagement.vue'),
                        meta: {
                            title: '教师管理',
                            role: 2,
                            parentName: ['schoolEducational']
                        },
                    },
                    {
                        path: '/school/educational/judges',
                        name: 'educationalJudges',
                        component: () => import('../views/school/educationalManage/JudgesManagement.vue'),
                        meta: {
                            title: '评委管理',
                            role: 2,
                            parentName: ['schoolEducational']
                        },
                    },
                ]
            },
            {
                path: '/school/certificate',
                name: 'schoolCertificate',
                redirect: '/school/certificate/index',
                component: Main,
                meta: {
                    title: '证书管理',
                    icon: '&#xe6b8;',
                    role: 2
                },
                children: [
                    {
                        path: '/school/certificate/index',
                        name: 'schoolCertificateIndex',
                        component: () => import('../views/teacher/evaluationCenter/Index.vue'),
                        meta: {
                            title: '证书管理',
                            role: 2,
                            parentName: ['schoolCertificate','schoolCertificateIndex'],
                            level:2,
                        },
                    },
                    {
                        path: '/school/certificate/getCertificateList',
                        name: 'schoolCertificateGetCertificateList',
                        component: () => import('../views/teacher/evaluationCenter/GetCertificateList.vue'),
                        meta: {
                            title: '已获得证书',
                            role: 2,
                            parentName: ['schoolCertificate','schoolCertificateIndex'],
                            hidden:true,
                            level:2,

                        },
                    },
                    {
                        path: '/school/certificate/noGetCertificateList',
                        name: 'schoolCertificateGetNoGetCertificateList',
                        component: () => import('../views/teacher/evaluationCenter/NoGetCertificateList.vue'),
                        meta: {
                            title: '未获得证书',
                            role: 2,
                            parentName: ['schoolCertificate','schoolCertificateIndex'],
                            hidden:true,
                            level:2,
                        },
                    },
                    // {
                    //     path: '/school/certificate/generateCertificate',
                    //     name: 'schoolCertificateGenerateCertificate',
                    //     component: () => import('../views/teacher/evaluationCenter/GenerateCertificate.vue'),
                    //     meta: {
                    //         title: '生成证书',
                    //         role: 2,
                    //         parentName: ['schoolCertificate','schoolCertificateIndex'],
                    //         hidden:true,
                    //         level:2,
                    //     },
                    // },

                ],

            },
            {
                path: '/school/report',
                name: 'schoolReport',
                redirect: '/school/report/index',
                component: Main,
                meta: {
                    title: '报告管理',
                    icon: '&#xe6b7;',
                    role: 2
                },
                children: [
                    {
                        path: '/school/report/index',
                        name: 'schoolReportIndex',
                        component: () => import('../views/school/reportManagement/Index.vue'),
                        meta: {
                            title: '报告管理',
                            role: 2,
                            parentName: ['schoolReport'],
                            level: 2
                        },
                    },
                    {
                        path: '/school/report/detail',
                        name: 'schoolReportDetail',
                        component: () => import('../views/school/reportManagement/ReportDetail.vue'),
                        meta: {
                            title: '报告管理-详情',
                            role: 2,
                            parentName: ['schoolReport','schoolReportIndex'],
                            level: 2,
                        },
                    },
                    {
                        path: '/school/report/singleReport',
                        name: 'schoolSingleReport',
                        component: () => import('../views/school/reportManagement/SingleReport.vue'),
                        meta: {
                            title: '报告管理-详情',
                            role: 2,
                            parentName: ['schoolReport','schoolReportIndex','schoolReportDetail'],
                            hidden:true,
                            level:2,
                            showMenu:false
                        },
                    },
                ]
            },
            {
                path: '/school/data',
                name: 'schoolData',
                redirect: '/school/data/index',
                component: Main,
                meta: {
                    title: '数据中心',
                    icon: '&#xe70e;',
                    role: 2
                },
                children: [
                    {
                        path: '/school/data/index',
                        name: 'schoolDataIndex',
                        component: () => import('../views/teacher/dataCenter/Index.vue'),
                        meta: {
                            title: '数据中心',
                            role: 2,
                            parentName: ['schoolData'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/school/data/detail',
                        name: 'schoolDataDetail',
                        component: () => import('../views/teacher/dataCenter/Detail.vue'),
                        meta: {
                            title: '班级数据',
                            role: 2,
                            parentName: ['schoolData']
                        }
                    },
                ]
            },
        ]
    },

    {
        path: '/school/certificates',
        name: 'schoolCertificates',
        redirect: '/school/certificates/index',
        component: SchoolLayoutDataCenter,
        children: [
            {
                path: '/school/certificates',
                name: 'schoolCertificate',
                redirect: '/school/certificates/index',
                component: Main,
                meta: {
                    title: '证书管理',
                    role: 2
                },
                children: [
                    {
                        path: '/school/certificate/viewCertificate',
                        name: 'schoolCertificateViewCertificate',
                        component: () => import('../views/teacher/evaluationCenter/ViewCertificate.vue'),
                        meta: {
                            title: '查看证书',
                            role: 2,
                            parentName: ['schoolCertificate','schoolCertificateIndex'],
                            hidden:true,
                            level:2,
                        },
                    },
                ]
            },
        ]
    }
]

export const teacherRoutes = [
    {
        path: '/teacher',
        name: 'teacher',
        redirect: '/teachingCenter/index',
        component: TeacherLayout,
        children: [
            {
                path: '/teachingCenter',
                name: 'teachingCenter',
                redirect: '/teachingCenter/index',
                component: TeacherCourseLayout,
                meta: {
                    title: '教学中心',
                    icon: '&#xe65a;',
                    childrenName: ['literacyAssessment', 'evaluationDetail'],
                    role: 3
                },
                children: [
                    {
                        path: '/teachingCenter/index',
                        name: 'teacherCourseIndex',
                        component: () => import('../views/teacher/teachingCenter/teacherIndex.vue'),
                        meta: {
                            title: '课程-首页',
                            role: 3,
                            parentName: ['teachingCenter'],
                            hidden: true,
                            tabName:'teacherCourseIndex'
                        }
                    },
                    {
                        path: '/teachingCenter/teacherFeatured',
                        name: 'teacherFeatured',
                        component: () => import('../views/teacher/teachingCenter/teacherFeatured.vue'),
                        meta: {
                            title: '课程-首页',
                            role: 3,
                            parentName: ['teachingCenter'],
                            hidden: true,
                            tabName:'teacherFeatured'
                        },
                        children: [
                        ]
                    },
                    {
                        path: '/teachingCenter/examDetail',
                        name: 'teacherExamDetail',
                        component: () => import('../views/teacher/teachingCenter/ExamDetail'),
                        meta: {
                            title: '理论试卷详情',
                            role: 3,
                            parentName: ['teachingCenter'],
                            hidden: true,
                            tabName: 'teacherExamDetail'
                        }
                    },
                    {
                        path: '/teachingCenter/practiceDetail',
                        name: 'teacherPracticeDetail',
                        component: () => import('../views/teacher/teachingCenter/LookDetail'),
                        meta: {
                            title: '实操训练详情',
                            role: 3,
                            parentName: ['teachingCenter'],
                            hidden: true,
                            tabName: 'teacherPracticeDetail'
                        }
                    },
                    {
                        path: '/teachingCenter/teacherMatingDetail',
                        name: 'teacherMatingDetail',
                        component: () => import('../views/teacher/teachingCenter/teacherMatingDetail'),
                        meta: {
                            title: '课程-个人资源',
                            role: 3,
                            parentName: ['teachingCenter'],
                            hidden: true,
                            tabName:'teacherMatingDetail'
                        }
                    },
                ]
            },
            {
                path: '/teachingCenter/literacyAssessment',
                name: 'literacyAssessment',
                component: () => import('../views/teacher/teachingCenter/LiteracyAssessment.vue'),
                meta: {
                    title: '素养评价',
                    role: 3,
                    hiddenMenu: true,
                    tabName: 'literacyAssessment',
                    customerView: true
                }
            },
            {
                path: '/teachingCenter/evaluationDetail',
                name: 'evaluationDetail',
                component: () => import('../views/teacher/teachingCenter/EvaluationDetail.vue'),
                meta: {
                    title: '学员素养评定',
                    role: 3,
                    hiddenMenu: true,
                    tabName: 'evaluationDetail',
                    customerView: true
                }
            },
            {
                path: '/trainingCenter',
                name: 'trainingCenter',
                redirect: '/trainingCenter/examTraining',
                component: Main,
                meta: {
                    title: '训练中心',
                    icon: '&#xe615;',
                    role: 3
                },
                children: [
                    {
                        path: '/trainingCenter/examTraining',
                        name: 'trainingCenterExamTraining',
                        component: () => import('../views/teacher/trainingCenter/ExamTraining.vue'),
                        meta: {
                            title: '考试训练',
                            role: 3,
                            parentName: ['trainingCenter'],
                            isActiveName: 'trainingCenterExamTraining'
                        },
                    },
                    {
                        path: '/trainingCenter/examTrainDetail',
                        name: 'trainingCenterExamTrainDetail',
                        component: () => import('../views/teacher/trainingCenter/ExamTrainingDetail'),
                        meta: {
                            title: '试卷详情',
                            role: 3,
                            parentName: ['trainingCenter', 'trainingCenterExamTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterExamTraining'
                        },
                    },
                    {
                        path: '/trainingCenter/examTrainAnswerDetail',
                        name: 'trainingCenterExamAnswerDetail',
                        component: () => import('../views/teacher/trainingCenter/ExamAnswerDetail'),
                        meta: {
                            title: '答题详情',
                            role: 3,
                            parentName: ['trainingCenter', 'trainingCenterExamTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterExamTraining'
                        },
                    },
                    {
                        path: '/trainingCenter/examTrainStudentAnswerDetail',
                        name: 'trainingCenterExamStudentAnswerDetail',
                        component: () => import('../views/teacher/trainingCenter/ExamStudentAnswerDetail'),
                        meta: {
                            title: '学生答题详情',
                            role: 3,
                            parentName: ['trainingCenter', 'trainingCenterExamTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterExamTraining'
                        },
                    },
                    {
                        path: '/trainingCenter/practicalTraining',
                        name: 'trainingCenterPracticalTraining',
                        component: () => import('../views/teacher/trainingCenter/PracticalTraining.vue'),
                        meta: {
                            title: '实操训练',
                            role: 3,
                            parentName: ['trainingCenter'],
                            isActiveName: 'trainingCenterPracticalTraining'
                        },
                    },
                    {
                        path:'/trainingCenter/practicalTraining/lookDetail',
                        name:'trainingCenterPracticalTrainingLookDetail',
                        component: () => import('../views/teacher/trainingCenter/LookDetail.vue'),
                        meta: {
                            title:'查看详情',
                            role:3,
                            parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterPracticalTraining'
                        }
                    },
                    {
                        path:'/trainingCenter/practicalTraining/answerDetail',
                        name:'trainingCenterPracticalTrainingAnswerDetail',
                        component: () => import('../views/teacher/trainingCenter/AnswerDetail.vue'),
                        meta: {
                            title:'答题详情',
                            role:3,
                            parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterPracticalTraining'
                        }
                    },
                    {
                        path:'/trainingCenter/practicalTraining/lookStudentDetail',
                        name:'trainingCenterPracticalTrainingLookStudentDetail',
                        component: () => import('../views/teacher/trainingCenter/LookStudentDetail.vue'),
                        meta: {
                            title:'商品信息采集与处理-查看详情',
                            role:3,
                            parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterPracticalTraining'
                        }
                    },
                    {
                        path:'/trainingCenter/practicalTraining/answerDetailService',
                        name:'trainingCenterPracticalTrainingAnswerDetailService',
                        component: () => import('../components/teacher/examCenter/examData/StoreCustomer.vue'),
                        meta: {
                            title:'网店客户服务-查看详情',
                            role:3,
                            parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterPracticalTraining'
                        }
                    },
                    {
                        path:'/trainingCenter/practicalTraining/answerDetailServiceDetail',
                        name:'trainingCenterPracticalTrainingAnswerDetailServiceDetail',
                        component: () => import('../components/teacher/examCenter/examData/AnswerDetailServiceDetail.vue'),
                        meta: {
                            title:'网店客户服务-查看详情',
                            role:3,
                            parentName: ['trainingCenter', 'trainingCenterPracticalTraining'],
                            hidden: true,
                            isActiveName: 'trainingCenterPracticalTraining'
                        }
                    },
                ]
            },
            {
                path: '/examCenter',
                name: 'examCenter',
                redirect: '/examCenter/examManagement',
                component: Main,
                meta: {
                    title: '考试中心',
                    icon: '&#xe62f;',
                    role: 3
                },
                children: [
                    {
                        path: '/examCenter/examManagement',
                        name: 'examCenterExamManagement',
                        component: () => import('../views/teacher/examCenter/ExamManagement.vue'),
                        meta: {
                            title: '考试管理',
                            role: 3,
                            parentName: ['examCenter'],
                            isActiveName: 'examCenterExamManagement'
                        },
                    },
                    {
                        path: '/examCenter/create',
                        name: 'examCenterCreate',
                        component: () => import('../views/teacher/examCenter/ExamCreate'),
                        meta: {
                            title: '创建考试',
                            role: 3,
                            parentName: ['examCenter', 'examCenterExamManagement'],
                            hidden: true,
                            isActiveName: 'examCenterExamManagement'
                        },
                    },
                    {
                        path: '/examCenter/examData',
                        name: 'examCenterExamData',
                        component: () => import('../views/teacher/examCenter/ExamData.vue'),
                        meta: {
                            title: '考试数据',
                            role: 3,
                            parentName: ['examCenter'],
                            isActiveName: 'examCenterExamData'
                        },
                    },
                    {
                        path: '/examCenter/examData/student',
                        name: 'examCenterExamDataStudent',
                        component: () => import('../views/teacher/examCenter/ExamDataStudent'),
                        meta: {
                            title: '学生数据',
                            role: 3,
                            parentName: ['examCenter', 'examCenterExamData'],
                            hidden: true,
                            isActiveName: 'examCenterExamData'
                        },
                    },
                    {
                        path: '/examCenter/examData/storeCustomerDetail',
                        name: 'examCenterExamDataStoreCustomerDetail',
                        component: () => import('../components/teacher/examCenter/examData/ExamStoreCustomerDetail'),
                        meta: {
                            title: '网店客户服务-查看详情',
                            role: 3,
                            parentName: ['examCenter'],
                            hidden: true,
                            isActiveName: 'examCenterExamData'
                        },
                    },
                    {
                        path: '/examCenter/examData/detail',
                        name: 'examCenterExamDataDetail',
                        component: ExamDataLayout,
                        meta: {
                            title: '考试数据详情',
                            role: 3,
                            parentName: ['examCenter', 'examCenterExamData'],
                            hidden: true,
                            isActiveName: 'examCenterExamData'
                        },
                        children: [
                            {
                                path: '/examCenter/examData/theory',
                                name: 'examCenterExamDataTheory',
                                component: () => import('../components/teacher/examCenter/examData/TheoryList'),
                                meta: {
                                    title: '理论题',
                                    tabName: 'examCenterExamDataTheory',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterExamData'],
                                    isActiveName: 'examCenterExamData'
                                },
                            },
                            {
                                path: '/examCenter/examData/goodsInfo',
                                name: 'examCenterExamDataGoodsInfo',
                                component: () => import('../components/teacher/examCenter/examData/GoodsInfo'),
                                meta: {
                                    title: '商品信息采集与处理',
                                    tabName: 'examCenterExamDataGoodsInfo',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterExamData'],
                                    isActiveName: 'examCenterExamData'
                                },
                            },
                            {
                                path: '/examCenter/examData/storeDecorate',
                                name: 'examCenterExamDataStoreDecorate',
                                component: () => import('../components/teacher/examCenter/examData/StoreDecorate'),
                                meta: {
                                    title: '网店装修',
                                    tabName: 'examCenterExamDataStoreDecorate',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterExamData'],
                                    isActiveName: 'examCenterExamData'
                                },
                            },
                            {
                                path: '/examCenter/examData/storeManage',
                                name: 'examCenterExamDataStoreManage',
                                component: () => import('../components/teacher/examCenter/examData/StoreManage'),
                                meta: {
                                    title: '网店管理',
                                    tabName: 'examCenterExamDataStoreManage',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterExamData'],
                                    isActiveName: 'examCenterExamData'
                                },
                            },
                            {
                                path: '/examCenter/examData/networkPromote',
                                name: 'examCenterExamDataNetworkPromote',
                                component: () => import('../components/teacher/examCenter/examData/NetworkPromote'),
                                meta: {
                                    title: '网络推广',
                                    tabName: 'examCenterExamDataNetworkPromote',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterExamData'],
                                    isActiveName: 'examCenterExamData'
                                },
                            },
                            {
                                path: '/examCenter/examData/storeCustomer',
                                name: 'examCenterExamDataStoreCustomer',
                                component: () => import('../components/teacher/examCenter/examData/ExamStoreCustomer'),
                                meta: {
                                    title: '网店客户服务',
                                    tabName: 'examCenterExamDataStoreCustomer',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterExamData'],
                                    isActiveName: 'examCenterExamData'
                                },
                            },
                            {
                                path: '/examCenter/examData/eCommerceData',
                                name: 'examCenterExamDataECommerceData',
                                component: () => import('../components/teacher/examCenter/examData/ECommerceData'),
                                meta: {
                                    title: '电子商务数据收集与清洗',
                                    tabName: 'examCenterExamDataECommerceData',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterExamData'],
                                    isActiveName: 'examCenterExamData'
                                },
                            },
                        ]
                    },
                    {
                        path: '/examCenter/examData/freightDetail',
                        name: 'examCenterExamDataFreightDetail',
                        component: () => import('../components/teacher/examCenter/examData/FreightDetail'),
                        meta: {
                            title: '查看运费详情',
                            tabName: 'examCenterExamDataFreightDetail',
                            role: 3,
                            parentName: ['examCenter', 'examCenterExamData'],
                            hidden:true,
                            level:2,
                            isActiveName: 'examCenterExamData'
                        },
                    },
                    {
                        path: '/examCenter/trainingData',
                        name: 'examCenterTrainingData',
                        component: () => import('../views/teacher/examCenter/TrainingData.vue'),
                        meta: {
                            title: '实训数据',
                            role: 3,
                            parentName: ['examCenter'],
                            isActiveName: 'examCenterTrainingData'
                        },
                    },
                    {
                        path: '/examCenter/trainingData/student',
                        name: 'examCenterTrainingDataStudent',
                        component: () => import('../views/teacher/examCenter/TrainingDataStudent'),
                        meta: {
                            title: '学生数据',
                            role: 3,
                            parentName: ['examCenter', 'examCenterTrainingData'],
                            hidden: true,
                            isActiveName: 'examCenterTrainingData'
                        },
                    },
                    {
                        path: '/examCenter/trainingData/storeCustomerPracticalDetail',
                        name: 'examCenterTrainingDataStoreCustomerPracticalDetail',
                        component: () => import('../components/teacher/examCenter/examData/StoreCustomerPracticalDetail'),
                        meta: {
                            title: '网店客户服务-查看详情',
                            role: 3,
                            hidden: true,
                            parentName: ['examCenter'],
                            isActiveName: 'examCenterTrainingData'
                        },
                    },
                    {
                        path: '/examCenter/trainingData/detail',
                        name: 'examCenterTrainingDataDetail',
                        component: TrainDataLayout,
                        meta: {
                            title: '实训数据详情',
                            role: 3,
                            parentName: ['examCenter', 'examCenterTrainingData'],
                            hidden: true,
                            isActiveName: 'examCenterTrainingData'
                        },
                        children: [
                            {
                                path: '/examCenter/trainingData/theory',
                                name: 'examCenterTrainingDataTheory',
                                component: () => import('../components/teacher/examCenter/examData/TheoryList'),
                                meta: {
                                    title: '理论题',
                                    tabName: 'examCenterTrainingDataTheory',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterTrainingData'],
                                    isActiveName: 'examCenterTrainingData'
                                },
                            },
                            {
                                path: '/examCenter/trainingData/goodsInfo',
                                name: 'examCenterTrainingDataGoodsInfo',
                                component: () => import('../components/teacher/examCenter/examData/GoodsInfo'),
                                meta: {
                                    title: '商品信息采集与处理',
                                    tabName: 'examCenterTrainingDataGoodsInfo',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterTrainingData'],
                                    isActiveName: 'examCenterTrainingData'
                                },
                            },
                            {
                                path: '/examCenter/trainingData/storeDecorate',
                                name: 'examCenterTrainingDataStoreDecorate',
                                component: () => import('../components/teacher/examCenter/examData/StoreDecorate'),
                                meta: {
                                    title: '网店装修',
                                    tabName: 'examCenterTrainingDataStoreDecorate',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterTrainingData'],
                                    isActiveName: 'examCenterTrainingData'
                                },
                            },
                            {
                                path: '/examCenter/trainingData/storeManage',
                                name: 'examCenterTrainingDataStoreManage',
                                component: () => import('../components/teacher/examCenter/examData/StoreManage'),
                                meta: {
                                    title: '网店管理',
                                    tabName: 'examCenterTrainingDataStoreManage',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterTrainingData'],
                                    isActiveName: 'examCenterTrainingData'
                                },
                            },
                            {
                                path: '/examCenter/trainingData/networkPromote',
                                name: 'examCenterTrainingDataNetworkPromote',
                                component: () => import('../components/teacher/examCenter/examData/NetworkPromote'),
                                meta: {
                                    title: '网络推广',
                                    tabName: 'examCenterTrainingDataNetworkPromote',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterTrainingData'],
                                    isActiveName: 'examCenterTrainingData'
                                },
                            },
                            {
                                path: '/examCenter/trainingData/storeCustomer',
                                name: 'examCenterTrainingDataStoreCustomer',
                                component: () => import('../components/teacher/examCenter/examData/PracticalStoreCustomer'),
                                meta: {
                                    title: '网店客户服务',
                                    tabName: 'examCenterTrainingDataStoreCustomer',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterTrainingData'],
                                    isActiveName: 'examCenterTrainingData'
                                },
                            },
                            {
                                path: '/examCenter/trainingData/eCommerceData',
                                name: 'examCenterTrainingDataECommerceData',
                                component: () => import('../components/teacher/examCenter/examData/ECommerceData'),
                                meta: {
                                    title: '电子商务数据收集与清洗',
                                    tabName: 'examCenterTrainingDataECommerceData',
                                    role: 3,
                                    parentName: ['examCenter', 'examCenterTrainingData'],
                                    isActiveName: 'examCenterTrainingData'
                                },
                            },
                        ]
                    },
                ]
            },
            {
                path: '/evaluationCenter',
                name: 'evaluationCenter',
                redirect: '/evaluationCenter/scoreManagement',
                component: Main,
                meta: {
                    title: '评价中心',
                    icon: '&#xe663;',
                    role: 3
                },
                children: [
                    {
                        path: '/evaluationCenter/scoreManagement',
                        name: 'evaluationCenterScoreManagement',
                        component: () => import('../views/teacher/evaluationCenter/ScoreManagement.vue'),
                        meta: {
                            title: '评分管理',
                            role: 3,
                            parentName: ['evaluationCenter'],
                            isActiveName: 'evaluationCenterScoreManagement'
                        },
                    },
                    {
                        path: '/evaluationCenter/theoreticalQuestions',
                        name: 'evaluationCenterTheoreticalQuestions',
                        redirect: '/evaluationCenter/theoreticalQuestions/index',
                        component: JudgesTypeLayout,
                        meta: {
                            title: '理论题',
                            role: 3,
                            parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                            hidden: true,
                            isActiveName: 'evaluationCenterScoreManagement'
                        },
                        children: [
                            {
                                path: '/evaluationCenter/theoreticalQuestions/index',
                                name: 'evaluationCenterTheoreticalQuestionsIndex',
                                component: () => import('../views/judges/theoreticalQuestions/Index.vue'),
                                meta: {
                                    title: '理论题',
                                    role: 3,
                                    tabName: 'evaluationCenterTheoreticalQuestionsIndex',
                                    parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                    isActiveName: 'evaluationCenterScoreManagement'
                                },
                            },
                            {
                                path: '/evaluationCenter/theoreticalQuestions/markTheoryPaper',
                                name: 'evaluationCenterTheoreticalQuestionsMarkTheoryPaper',
                                component: () => import('../views/judges/theoreticalQuestions/MarkTheoryPaper.vue'),
                                meta: {
                                    title: '批改',
                                    role: 3,
                                    tabName: 'evaluationCenterTheoreticalQuestionsIndex',
                                    parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                    isActiveName: 'evaluationCenterScoreManagement'
                                },
                            },
                            {
                                path: '/evaluationCenter/goodsInfo/index',
                                name: 'evaluationCenterGoodsInfoIndex',
                                component: () => import('../views/judges/goodsInfo/Index.vue'),
                                meta: {
                                    title: '商品信息采集与处理',
                                    role: 3,
                                    tabName: 'evaluationCenterGoodsInfoIndex',
                                    parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                    isActiveName: 'evaluationCenterScoreManagement'
                                },
                            },
                            {
                                path: '/evaluationCenter/onlineShopDecoration/index',
                                name: 'evaluationCenterOnlineShopDecorationIndex',
                                component: () => import('../views/judges/onlineShopDecoration/Index.vue'),
                                meta: {
                                    title: '网店装修',
                                    role: 3,
                                    tabName: 'evaluationCenterOnlineShopDecorationIndex',
                                    parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                    isActiveName: 'evaluationCenterScoreManagement'
                                },
                            },
                            {
                                path: '/evaluationCenter/webPromotion/index',
                                name: 'evaluationCenterWebPromotionIndex',
                                component: () => import('../views/judges/webPromotion/Index.vue'),
                                meta: {
                                    title: '网络推广',
                                    role: 3,
                                    tabName: 'evaluationCenterWebPromotionIndex',
                                    parentName: ['evaluationCenter', 'evaluationCenterScoreManagement'],
                                    isActiveName: 'evaluationCenterScoreManagement'
                                },
                            }
                        ]
                    },
                    {
                        path: '/evaluationCenter/certificateManagement',
                        name: 'evaluationCenterCertificateManagement',
                        redirect: '/evaluationCenter/certificateManagement/index',
                        component: CertificateLayout,
                        // component: () => import('../views/teacher/evaluationCenter/CertificateManagement.vue'),
                        meta: {
                            title: '证书管理',
                            role: 3,
                            parentName: ['evaluationCenter'],
                            isActiveName: 'evaluationCenterCertificateManagement',
                        },
                        children: [
                            {
                                path: '/evaluationCenter/certificateManagement/index',
                                name: 'evaluationCenterCertificateManagementIndex',
                                component: () => import('../views/teacher/evaluationCenter/Index.vue'),
                                meta: {
                                    title: '证书管理',
                                    role: 3,
                                    tabName: 'evaluationCenterCertificateManagementIndex',
                                    parentName: ['evaluationCenter','evaluationCenterCertificateManagement'],
                                    isActiveName: 'evaluationCenterCertificateManagement'
                                },
                            },
                            {
                                path: '/evaluationCenter/certificateManagement/model',
                                name: 'evaluationCenterCertificateManagementModel',
                                component: () => import('../views/teacher/evaluationCenter/Model.vue'),
                                meta: {
                                    title: '证书模板',
                                    role: 3,
                                    tabName: 'evaluationCenterCertificateManagementModel',
                                    parentName: ['evaluationCenter','evaluationCenterCertificateManagement'],
                                    isActiveName: 'evaluationCenterCertificateManagement'
                                },
                            },
                        ],
                    },
                    {
                        path: '/evaluationCenter/getCertificateList',
                        name: 'evaluationCenterGetCertificateList',
                        component: () => import('../views/teacher/evaluationCenter/GetCertificateList.vue'),
                        meta: {
                            title: '已获得证书',
                            role: 3,
                            parentName: ['evaluationCenter','evaluationCenterCertificateManagement'],
                            hidden:true,
                            isActiveName: 'evaluationCenterCertificateManagement'
                        },
                    },
                    {
                        path: '/evaluationCenter/noGetCertificateList',
                        name: 'evaluationCenterNoGetCertificateList',
                        component: () => import('../views/teacher/evaluationCenter/NoGetCertificateList.vue'),
                        meta: {
                            title: '未获得证书',
                            role: 3,
                            parentName: ['evaluationCenter','evaluationCenterCertificateManagement'],
                            hidden:true,
                            isActiveName: 'evaluationCenterCertificateManagement'
                        },
                    },
                    {
                        path: '/evaluationCenter/viewCertificate',
                        name: 'evaluationCenterViewCertificate',
                        component: () => import('../views/teacher/evaluationCenter/ViewCertificate.vue'),
                        meta: {
                            title: '查看证书',
                            role: 3,
                            parentName: ['evaluationCenter','evaluationCenterCertificateManagement'],
                            hidden:true,
                            level:2,
                            isActiveName: 'evaluationCenterCertificateManagement'
                        },
                    },
                    {
                        path: '/evaluationCenter/generateCertificate',
                        name: 'evaluationCenterGenerateCertificate',
                        component: () => import('../views/teacher/evaluationCenter/GenerateCertificate.vue'),
                        meta: {
                            title: '生成证书',
                            role: 3,
                            parentName: ['evaluationCenter','evaluationCenterCertificateManagement'],
                            hidden:true,
                            level:2,
                        },
                    },
                    {
                        path: '/evaluationCenter/certificateModel',
                        name: 'evaluationCenterCertificateModel',
                        component: () => import('../views/teacher/evaluationCenter/CertificateModel.vue'),
                        meta: {
                            title: '添加证书模板',
                            role: 3,
                            parentName: ['evaluationCenter','evaluationCenterCertificateManagement'],
                            hidden:true,
                            level:2,
                            isActiveName: 'evaluationCenterCertificateManagement'
                        },
                    },
                    {
                        path: '/evaluationCenter/reportManagement',
                        name: 'evaluationCenterReportManagement',
                        component: () => import('../views/teacher/evaluationCenter/ReportManagement.vue'),
                        meta: {
                            title: '报告管理',
                            role: 3,
                            parentName: ['evaluationCenter'],
                            isActiveName: 'evaluationCenterReportManagement'
                        },
                    },
                    {
                        path: '/evaluationCenter/reportManagement/detail',
                        name: 'ReportManagementDetail',
                        component: () => import('../components/teacher/reportManage/reportDetail'),
                        meta: {
                            title: '报告管理-详情',
                            role: 3,
                            parentName: ['evaluationCenter','evaluationCenterReportManagement'],
                            hidden:true,
                            isActiveName: 'evaluationCenterReportManagement'
                        },
                    },
                    {
                        path: '/evaluationCenter/reportManagement/singleReport',
                        name: 'ReportManagementSingleReport',
                        component: () => import('../views/teacher/evaluationCenter/SingleReport'),
                        meta: {
                            title: '报告管理-详情',
                            role: 3,
                            parentName: ['evaluationCenter'],
                            hidden:true,
                            level:2,
                            isActiveName: 'evaluationCenterReportManagement'
                        },
                    },
                ]
            },
            {
                path: '/dataCenter',
                name: 'dataCenter',
                redirect: '/dataCenter/index',
                component: Main,
                meta: {
                    title: '数据中心',
                    icon: '&#xe70e;',
                    role: 3
                },
                children: [
                    {
                        path: '/dataCenter/index',
                        name: 'dataCenterIndex',
                        component: () => import('../views/teacher/dataCenter/Index.vue'),
                        meta: {
                            title: '数据中心',
                            role: 3,
                            parentName: ['dataCenter'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/dataCenter/detail',
                        name: 'dataCenterDetail',
                        component: () => import('../views/teacher/dataCenter/Detail.vue'),
                        meta: {
                            title: '班级数据',
                            role: 3,
                            parentName: ['dataCenter']
                        }
                    },
                ]
            },
            {
                path: '/educationCenter',
                name: 'educationCenter',
                redirect: '/educationCenter/ClassManagement',
                component: Main,
                meta: {
                    title: '教务中心',
                    icon: '&#xe66d;',
                    role: 3
                },
                children: [
                    {
                        path: '/educationCenter/classManagement',
                        name: 'educationCenterClassManagement',
                        component: () => import('../views/teacher/educationCenter/ClassManagement.vue'),
                        meta: {
                            title: '班级管理',
                            role: 3,
                            parentName: ['educationCenter'],
                            isActiveName: 'educationCenterClassManagement'
                        },
                    },
                    {
                        path: '/educationCenter/studentManagement',
                        name: 'educationCenterStudentManagement',
                        component: () => import('../views/teacher/educationCenter/StudentManagement.vue'),
                        meta: {
                            title: '学生管理',
                            role: 3,
                            parentName: ['educationCenter'],
                            isActiveName: 'educationCenterStudentManagement'
                        },
                    }
                ]
            },
            {
                path: '/dataEvaluation',
                name: 'dataEvaluation',
                redirect: '/dataEvaluation/index',
                component: Main,
                meta: {
                    title: '综合数据评价',
                    icon: '&#xe70e;',
                    role: 3
                },
                children: [
                    {
                        path: '/dataEvaluation/index',
                        name: 'dataEvaluationIndex',
                        component: () => import('../views/teacher/dataEvaluation/Index.vue'),
                        meta: {
                            title: '综合数据评价',
                            role: 3,
                            parentName: ['dataEvaluation'],
                            hidden: true,
                        }
                    },
                ]
            },
        ]
    }
]
export const judgesRoutes = [
    {
        path: '/judges',
        name: 'judges',
        redirect: '/judges/grading/index',
        component: JudgesLayout,
        children: [
            {
                path: '/judges/grading',
                name: 'judgesGrading',
                redirect: '/judges/grading/index',
                component: Main,
                meta: {
                    title: '评分管理',
                    icon: '&#xe663;',
                    role: 4
                },
                children: [
                    {
                        path: '/judges/grading/index',
                        name: 'judgesGradingIndex',
                        component: () => import('../views/judges/grading/Index.vue'),
                        meta: {
                            title: '评分管理',
                            role: 4,
                            parentName: ['judgesGrading']
                        }
                    },
                    {
                        path: '/judges/theoreticalQuestions',
                        name: 'judgesTheoreticalQuestions',
                        redirect: '/judges/theoreticalQuestions/index',
                        component: JudgesTypeLayout,
                        meta: {
                            title: '理论题',
                            role: 4
                        },
                        children: [
                            {
                                path: '/judges/theoreticalQuestions/index',
                                name: 'judgesTheoreticalQuestionsIndex',
                                component: () => import('../views/judges/theoreticalQuestions/Index.vue'),
                                meta: {
                                    title: '理论题',
                                    role: 4,
                                    tabName: 'judgesTheoreticalQuestionsIndex',
                                    parentName: ['judgesGrading']
                                },
                            },
                            {
                                path: '/judges/theoreticalQuestions/markTheoryPaper',
                                name: 'judgesTheoreticalQuestionsMarkTheoryPaper',
                                component: () => import('../views/judges/theoreticalQuestions/MarkTheoryPaper.vue'),
                                meta: {
                                    title: '批改',
                                    role: 4,
                                    tabName: 'judgesTheoreticalQuestionsIndex',
                                    parentName: ['judgesGrading', 'judgesTheoreticalQuestionsIndex']
                                },
                            },
                            {
                                path: '/judges/goodsInfo/index',
                                name: 'judgesGoodsInfoIndex',
                                component: () => import('../views/judges/goodsInfo/Index.vue'),
                                meta: {
                                    title: '商品信息采集与处理',
                                    role: 4,
                                    tabName: 'judgesGoodsInfoIndex',
                                    parentName: ['judgesGrading']
                                },
                            },
                            {
                                path: '/judges/onlineShopDecoration/index',
                                name: 'judgesOnlineShopDecorationIndex',
                                component: () => import('../views/judges/onlineShopDecoration/Index.vue'),
                                meta: {
                                    title: '网店装修',
                                    role: 4,
                                    tabName: 'judgesOnlineShopDecorationIndex',
                                    parentName: ['judgesGrading']
                                },
                            },
                            {
                                path: '/judges/webPromotion/index',
                                name: 'judgesWebPromotionIndex',
                                component: () => import('../views/judges/webPromotion/Index.vue'),
                                meta: {
                                    title: '网络推广',
                                    role: 4,
                                    tabName: 'judgesWebPromotionIndex',
                                    parentName: ['judgesGrading']
                                },
                            }
                        ]
                    },
                ]
            }
        ]
    }
]
export const studentRoutes = [
    {
        path: '/student',
        name: 'student',
        redirect: '/student/course/index',
        component: studentTrainingLayout,
        children: [
            {
                path: '/student/course',
                name: 'studentCourse',
                redirect: '/student/course/index',
                component: studentCourseLayout,
                meta: {
                    title: '教学中心',
                    icon: '&#xe6af;',
                    role: 5
                },
                children: [
                    {
                        path: '/student/course/index',
                        name: 'studentCourseIndex',
                        component: () => import('../views/student/train/course/Index.vue'),
                        meta: {
                            title: '教学中心',
                            role: 5,
                            parentName: ['studentCourse'],
                            level: 2,
                            hidden: true,
                            tabName: 'studentCourseIndex'
                        },
                    },
                    {
                        path: '/student/course/featured',
                        name: 'studentFeatured',
                        component: () => import('../views/student/train/course/studentFeatured.vue'),
                        meta: {
                            title: '课程-首页',
                            role: 5,
                            parentName: ['studentCourse'],
                            hidden: true,
                            tabName:'studentFeatured'
                        }
                    },
                    {
                        path: '/student/course/examDetail',
                        name: 'studentExamDetail',
                        component: () => import('../views/student/train/course/ExamDetail.vue'),
                        meta: {
                            title: '理论试卷详情',
                            role: 5,
                            parentName: ['studentCourse'],
                            hidden: true,
                            tabName: 'studentExamDetail'
                        }
                    },
                    {
                        path: '/student/course/MatingDetail',
                        name: 'studentMatingDetail',
                        component: () => import('../views/student/train/course/studentMatingDetail.vue'),
                        meta: {
                            title: '课程-个人资源',
                            role: 5,
                            parentName: ['studentCourse'],
                            hidden: true,
                            tabName:'studentMatingDetail'
                        }
                    },
                ]
            },
            {
                path: '/student/trainCenter',
                name: 'studentTrainCenter',
                redirect: '/student/trainCenter/index',
                component: Main,
                meta: {
                    title: '训练中心',
                    icon: '&#xe6b5;',
                    role: 5
                },
                children: [
                    {
                        path: '/student/trainCenter/index',
                        name: 'studentTrainCenterIndex',
                        component: () => import('../views/student/train/trainCenter/Index.vue'),
                        meta: {
                            title: '考试训练',
                            role: 5,
                            parentName: ['studentTrainCenter']
                        },
                    },
                    {
                        path: '/student/trainCenter/startTrainExam',
                        name: 'studentTrainCenterStartTrainExam',
                        component: () => import('../views/student/train/trainCenter/StartTrainExam.vue'),
                        meta: {
                            title: '考试训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterIndex'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/lookAnswerDetail',
                        name: 'studentTrainCenterLookAnswerDetail',
                        component: () => import('../views/student/train/trainCenter/LookAnswerDetail.vue'),
                        meta: {
                            title: '答题详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterIndex'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/lookAnswerDetail/paperDetail',
                        name: 'studentTrainCenterLookAnswerDetailPaperDetail',
                        component: () => import('../views/student/train/trainCenter/PaperDetail.vue'),
                        meta: {
                            title: '查看详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterIndex'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/practice',
                        name: 'studentTrainCenterPractice',
                        component: () => import('../views/student/train/trainCenter/Practice.vue'),
                        meta: {
                            title: '实操训练',
                            role: 5,
                            parentName: ['studentTrainCenter'],
                        }
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/startTraining',
                        name: 'studentTrainCenterGoodsInfoStartTraining',
                        component: () => import('../views/student/exam/goodsInfo/Index.vue'),
                        meta: {
                            title: '开始训练-商品信息采集与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        }
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/starExam',
                        name: 'studentTrainCenterGoodsInfoStarExam',
                        component: GoodsInfoLayout,
                        meta: {
                            title: '商品信息采集与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [
                            {
                                path: '/student/trainCenter/goodsInfo/hotGoods',
                                name: 'studentTrainCenterGoodsInfoHotGoods',
                                component: () => import('../views/student/exam/goodsInfo/HotGoods.vue'),
                                meta: {
                                    title: '热门商品',
                                    tabName: 'studentTrainCenterGoodsInfoHotGoods',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/goodsInfo/goodsText',
                                name: 'studentTrainCenterGoodsInfoGoodsText',
                                component: () => import('../views/student/exam/goodsInfo/GoodsText.vue'),
                                meta: {
                                    title: '商品文字信息撰写',
                                    tabName: 'studentTrainCenterGoodsInfoGoodsText',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/goodsInfo/hotKeyword',
                                name: 'studentTrainCenterGoodsInfoHotKeyword',
                                component: () => import('../views/student/exam/goodsInfo/HotKeyword.vue'),
                                meta: {
                                    title: '热门关键词',
                                    tabName: 'studentTrainCenterGoodsInfoHotKeyword',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/selectClass',
                        name: 'studentTrainCenterGoodsInfoSelectClass',
                        component: () => import('../views/student/exam/goodsInfo/SelectClass.vue'),
                        meta: {
                            title: '选择分类',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/addGoods',
                        name: 'studentTrainCenterGoodsInfoAddGoods',
                        component: () => import('../views/student/exam/goodsInfo/GoodsAdd.vue'),
                        meta: {
                            title: '添加商品',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/goodsShoot',
                        name: 'studentTrainCenterGoodsInfoGoodsShoot',
                        component: () => import('../views/student/exam/goodsInfo/GoodsShoot.vue'),
                        meta: {
                            title: '商品拍摄与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },
                    {
                        path: '/student/trainCenter/goodsInfo/goodsVideoShoot',
                        name: 'studentTrainCenterGoodsInfoGoodsVideoShoot',
                        component: () => import('../views/student/exam/goodsInfo/GoodsVideoShoot.vue'),
                        meta: {
                            title: '商品视频拍摄与处理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true
                        },
                    },

                    {
                        path: '/student/trainCenter/startTraining',
                        name: 'studentTrainCenterStartTraining',
                        component: () => import('../views/student/exam/onlineShopManagement/Index.vue'),
                        meta: {
                            title: '网店管理-开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }

                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/starExam',
                        name: 'studentTrainCenterOnlineShopManagementStarExam',
                        component: GoodsShopLayout,
                        meta: {
                            title: '网店管理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [
                            {
                                path: '/student/trainCenter/onlineShopManagement/goodsIndex',
                                name: 'studentTrainCenterOnlineShopManagementsGoodsIndex',
                                component: () => import('../views/student/exam/onlineShopManagement/GoodsIndex.vue'),
                                meta: {
                                    title: '在售商品',
                                    tabName: 'studentTrainCenterOnlineShopManagementsGoodsIndex',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/hotKeyword',
                                name: 'studentTrainCenterOnlineShopManagementHotKeyword',
                                component: () => import('../views/student/exam/onlineShopManagement/HotKeyword.vue'),
                                meta: {
                                    title: '热门关键词',
                                    tabName: 'studentTrainCenterOnlineShopManagementHotKeyword',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/freightTemplate',
                                name: 'studentTrainCenterOnlineShopManagementFreightTemplate',
                                component: () => import('../views/student/exam/onlineShopManagement/FreightTemplate.vue'),
                                meta: {
                                    title: '运单模板',
                                    tabName: 'studentTrainCenterOnlineShopManagementFreightTemplate',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },

                    {
                        path: '/student/trainCenter/onlineShopManagement/studentGoodsCategory',
                        name: 'studentTrainCenterOnlineShopManagementStudentGoodsCategory',
                        component: () => import('../views/student/exam/onlineShopManagement/StudentGoodsCategory.vue'),
                        meta: {
                            title: '选择分类',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/StudentAddGoods',
                        name: 'studentTrainCenterOnlineShopManagementStudentAddGoods',
                        component: () => import('../views/student/exam/onlineShopManagement/StudentAddGoods.vue'),
                        meta: {
                            title: '添加商品',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/studentFreight',
                        name: 'studentTrainCenterOnlineShopManagementStudentFreight',
                        component: () => import('../views/student/exam/onlineShopManagement/StudentFreight.vue'),
                        meta: {
                            title: '添加运单模板',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                    },
                    {
                        path: '/student/trainCenter/onlineShopManagement/starExam',
                        name: 'studentTrainCenterOnlineShopManagementStarExam',
                        component: OrderLayout,
                        meta: {
                            title: '网店管理',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        },
                        children: [
                            {
                                path: '/student/trainCenter/onlineShopManagement/allOrder',
                                name: 'studentTrainCenterOnlineShopManagementsAllOrder',
                                component: () => import('../views/student/exam/onlineShopManagement/AllOrder.vue'),
                                meta: {
                                    title: '所有订单',
                                    tabName: 'studentTrainCenterOnlineShopManagementsAllOrder',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],

                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/delivered',
                                name: 'studentTrainCenterOnlineShopManagementDelivered',
                                component: () => import('../views/student/exam/onlineShopManagement/Delivered.vue'),
                                meta: {
                                    title: '待发货',
                                    tabName: 'studentTrainCenterOnlineShopManagementDelivered',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/deliverGoods',
                                name: 'studentTrainCenterOnlineShopManagementDeliverGoods',
                                component: () => import('../views/student/exam/onlineShopManagement/DeliverGoods.vue'),
                                meta: {
                                    title: '已发货',
                                    tabName: 'studentTrainCenterOnlineShopManagementDeliverGoods',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                            {
                                path: '/student/trainCenter/onlineShopManagement/salesOrder',
                                name: 'studentTrainCenterOnlineShopManagementSalesOrder',
                                component: () => import('../views/student/exam/onlineShopManagement/SalesOrder.vue'),
                                meta: {
                                    title: '售后订单',
                                    tabName: 'studentTrainCenterOnlineShopManagementSalesOrder',
                                    role: 5,
                                    parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                                },
                            },
                        ]
                    },
                    // 数据手机与清洗
                    {
                        path: '/student/trainCenter/startTraining/ECommerceDataCollectionAndCleaning',
                        name: 'studentTrainCenterStartTrainingECommerceDataCollectionAndCleaning',
                        component: () => import('../views/student/exam/ECommerceDataCollectionAndCleaning/Index.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 网店装修
                    {
                        path: '/student/trainCenter/startTraining/onlineStoreFitment',
                        name: 'studentTrainCenterStartTrainingOnlineStoreFitment',
                        component: () => import('../views/student/train/trainCenter/OnlineStoreFitment.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 网店推广
                    {
                        path: '/student/trainCenter/startTraining/networkPromotion',
                        name: 'studentTrainCenterStartTrainingNetworkPromotion',
                        component: () => import('../views/student/train/trainCenter/NetworkPromotion.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },

                    // 客服
                    {
                        path: '/student/trainCenter/startTraining/onlineShopCustomerService',
                        name: 'studentTrainCenterStartTrainingOnlineShopCustomerService',
                        component: () => import('../views/student/exam/onlineShopCustomerService/Index.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    // 数据手机与清洗
                    {
                        path: '/student/trainCenter/startTraining/ECommerceDataCollectionAndCleaning',
                        name: 'studentTrainCenterStartTrainingECommerceDataCollectionAndCleaning',
                        component: () => import('../views/student/exam/ECommerceDataCollectionAndCleaning/Index.vue'),
                        meta: {
                            title: '开始训练',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    {
                        path: '/student/trainCenter/answerDetail',
                        name: 'studentTrainCenterAnswerDetail',
                        component: () => import('../views/student/train/trainCenter/AnswerDetail.vue'),
                        meta: {
                            title: '答题详情',
                            role: 5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    {
                        path:'/student/trainCenter/lookDetail',
                        name:'studentTrainCenterLookDetail',
                        component: () => import('../views/student/train/trainCenter/LookDetail.vue'),
                        meta: {
                            title:'查看详情',
                            role:5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    {
                        path:'/student/trainCenter/lookDetailServiceDetail',
                        name:'studentTrainCenterLookDetailServiceDetail',
                        component: () => import('../views/student/train/trainCenter/LookDetailServiceDetail.vue'),
                        meta: {
                            title:'答题详情',
                            role:5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                    //商品信息采集与处理
                    {
                        path:'/student/trainCenter/goodsInfo/lookDetail',
                        name:'studentTrainCenterGoodsInfoLookDetail',
                        component: () => import('../views/student/train/trainCenter/goodsInfo/LookDetail.vue'),
                        meta: {
                            title:'商品信息采集与处理--查看详情',
                            role:5,
                            parentName: ['studentTrainCenter', 'studentTrainCenterPractice'],
                            hidden: true,
                        }
                    },
                ]
            }
        ]
    },
    {
        path: '/student/exam',
        name: 'studentExam',
        component: () => import('../views/student/exam/Exam.vue'),
        meta: {
            title: '考试界面',
            role: 5,
        }
    },
    {
        path: '/student/examing',
        name: 'studentExaming',
        redirect: '/student/examing/theoryTest/index',
        component: studentExamLayout,
        children: [
            {
                path: '/student/examing/theoryTest',
                name: 'studentExamingTheoryTest',
                redirect: '/student/examing/theoryTest/index',
                component: Main,
                meta: {
                    title: '理论考试',
                    icon: '&#xe6c2;',
                    role: 5
                },
                children: [
                    {
                        path: '/student/examing/theoryTest/index',
                        name: 'studentExamingTheoryTestIndex',
                        component: () => import('../views/student/exam/theoryTest/Index.vue'),
                        meta: {
                            title: '理论考试',
                            role: 5,
                            parentName: ['studentExamingTheoryTest'],
                        },
                    }
                ]
            },
            // {
            //     path: '/student/examing/goodsInfo',
            //     name: 'studentExamingGoodsInfo',
            //     redirect: '/student/examing/goodsInfo/index',
            //     component: Main,
            //     meta: {
            //         title: '商品信息采集与处理',
            //         role: 5
            //     },
            //     children: [
            //         {
            //             path: '/student/examing/goodsInfo/index',
            //             name: 'studentExamingGoodsInfoIndex',
            //             component: () => import('../views/student/exam/goodsInfo/Index.vue'),
            //             meta: {
            //                 title: '开始考试',
            //                 role: 5,
            //                 parentName: ['studentExamingGoodsInfo'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/goodsInfo/starExam',
            //             name: 'studentExamingGoodsInfoStarExam',
            //             component: GoodsInfoLayout,
            //             meta: {
            //                 title: '商品信息采集与处理',
            //                 role: 5,
            //                 parentName: ['studentExamingGoodsInfo'],
            //                 hidden: true,
            //             },
            //             children: [
            //                 {
            //                     path: '/student/examing/goodsInfo/hotGoods',
            //                     name: 'studentExamingGoodsInfoHotGoods',
            //                     component: () => import('../views/student/exam/goodsInfo/HotGoods.vue'),
            //                     meta: {
            //                         title: '热门商品',
            //                         tabName: 'studentExamingGoodsInfoHotGoods',
            //                         role: 5,
            //                         parentName: ['studentExamingGoodsInfo'],
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/goodsInfo/goodsText',
            //                     name: 'studentExamingGoodsInfoGoodsText',
            //                     component: () => import('../views/student/exam/goodsInfo/GoodsText.vue'),
            //                     meta: {
            //                         title: '商品文字信息撰写',
            //                         tabName: 'studentExamingGoodsInfoGoodsText',
            //                         role: 5,
            //                         parentName: ['studentExamingGoodsInfo'],
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/goodsInfo/hotKeyword',
            //                     name: 'studentExamingGoodsInfoHotKeyword',
            //                     component: () => import('../views/student/exam/goodsInfo/HotKeyword.vue'),
            //                     meta: {
            //                         title: '热门关键词',
            //                         tabName: 'studentExamingGoodsInfoHotKeyword',
            //                         role: 5,
            //                         parentName: ['studentExamingGoodsInfo'],
            //                     },
            //                 },
            //             ]
            //         },
            //         {
            //             path: '/student/examing/goodsInfo/selectClass',
            //             name: 'studentExamingGoodsInfoSelectClass',
            //             component: () => import('../views/student/exam/goodsInfo/SelectClass.vue'),
            //             meta: {
            //                 title: '选择分类',
            //                 role: 5,
            //                 parentName: ['studentExamingGoodsInfo'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/goodsInfo/addGoods',
            //             name: 'studentExamingGoodsInfoAddGoods',
            //             component: () => import('../views/student/exam/goodsInfo/GoodsAdd.vue'),
            //             meta: {
            //                 title: '添加商品',
            //                 role: 5,
            //                 parentName: ['studentExamingGoodsInfo'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/goodsInfo/goodsShoot',
            //             name: 'studentExamingGoodsInfoGoodsShoot',
            //             component: () => import('../views/student/exam/goodsInfo/GoodsShoot.vue'),
            //             meta: {
            //                 title: '商品拍摄与处理',
            //                 role: 5,
            //                 parentName: ['studentExamingGoodsInfo'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/goodsInfo/goodsVideoShoot',
            //             name: 'studentExamingGoodsInfoGoodsVideoShoot',
            //             component: () => import('../views/student/exam/goodsInfo/GoodsVideoShoot.vue'),
            //             meta: {
            //                 title: '商品视频拍摄与处理',
            //                 role: 5,
            //                 parentName: ['studentExamingGoodsInfo'],
            //             },
            //         },
            //     ]
            // },
            // {
            //     path: '/student/examing/onlineShopDecoration',
            //     name: 'studentExamingOnlineShopDecoration',
            //     redirect: '/student/examing/onlineShopDecoration/index',
            //     component: Main,
            //     meta: {
            //         title: '网店装修',
            //         role: 5
            //     },
            //     children: [
            //         {
            //             path: '/student/examing/onlineShopDecoration/index',
            //             name: 'studentExamingOnlineShopDecorationIndex',
            //             component: () => import('../views/student/exam/onlineShopDecoration/Index.vue'),
            //             meta: {
            //                 title: '网店装修',
            //                 role: 5,
            //                 parentName: ['studentExamingOnlineShopDecoration'],
            //             },
            //         }
            //     ]
            // },
            // {
            //     path: '/student/examing/onlineShopManagement',
            //     name: 'studentExamingOnlineShopManagement',
            //     redirect: '/student/examing/onlineShopManagement/index',
            //     component: Main,
            //     meta: {
            //         title: '网店管理',
            //         role: 5
            //     },
            //     children: [
            //         {
            //             path: '/student/examing/onlineShopManagement/index',
            //             name: 'studentExamingOnlineShopManagementIndex',
            //             component: () => import('../views/student/exam/onlineShopManagement/Index.vue'),
            //             meta: {
            //                 title: '开始考试',
            //                 role: 5,
            //                 parentName: ['studentExamingOnlineShopManagement'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/onlineShopManagement/starExam',
            //             name: 'studentExamingOnlineShopManagementStarExam',
            //             component: GoodsShopLayout,
            //             meta: {
            //                 title: '网店管理',
            //                 role: 5,
            //                 parentName: ['studentExamingOnlineShopManagement'],
            //                 hidden: true,
            //             },
            //             children: [
            //                 {
            //                     path: '/student/examing/onlineShopManagement/goodsIndex',
            //                     name: 'studentExamingOnlineShopManagementsGoodsIndex',
            //                     component: () => import('../views/student/exam/onlineShopManagement/GoodsIndex.vue'),
            //                     meta: {
            //                         title: '在售商品',
            //                         tabName: 'studentExamingOnlineShopManagementsGoodsIndex',
            //                         role: 5,
            //                         parentName: ['studentExamingOnlineShopManagement'],
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopManagement/hotKeyword',
            //                     name: 'studentExamingOnlineShopManagementHotKeyword',
            //                     component: () => import('../views/student/exam/onlineShopManagement/HotKeyword.vue'),
            //                     meta: {
            //                         title: '热门关键词',
            //                         tabName: 'studentExamingOnlineShopManagementHotKeyword',
            //                         role: 5,
            //                         parentName: ['studentExamingOnlineShopManagement'],
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopManagement/freightTemplate',
            //                     name: 'studentExamingOnlineShopManagementFreightTemplate',
            //                     component: () => import('../views/student/exam/onlineShopManagement/FreightTemplate.vue'),
            //                     meta: {
            //                         title: '运单模板',
            //                         tabName: 'studentExamingOnlineShopManagementFreightTemplate',
            //                         role: 5,
            //                         parentName: ['studentExamingOnlineShopManagement'],
            //                     },
            //                 },
            //             ]
            //         },
            //         {
            //             path: '/student/examing/onlineShopManagement/studentGoodsCategory',
            //             name: 'studentExamingOnlineShopManagementStudentGoodsCategory',
            //             component: () => import('../views/student/exam/onlineShopManagement/StudentGoodsCategory.vue'),
            //             meta: {
            //                 title: '选择分类',
            //                 role: 5,
            //                 parentName: ['studentExamingOnlineShopManagement'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/onlineShopManagement/StudentAddGoods',
            //             name: 'studentExamingOnlineShopManagementStudentAddGoods',
            //             component: () => import('../views/student/exam/onlineShopManagement/StudentAddGoods.vue'),
            //             meta: {
            //                 title: '添加商品',
            //                 role: 5,
            //                 parentName: ['studentExamingOnlineShopManagement'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/onlineShopManagement/studentFreight',
            //             name: 'studentExamingOnlineShopManagementStudentFreight',
            //             component: () => import('../views/student/exam/onlineShopManagement/StudentFreight.vue'),
            //             meta: {
            //                 title: '添加运单模板',
            //                 role: 5,
            //                 parentName: ['studentExamingOnlineShopManagement'],
            //             },
            //         },
            //         {
            //             path: '/student/examing/onlineShopManagement/starExam',
            //             name: 'studentExamingOnlineShopManagementStarExams',
            //             component: OrderLayout,
            //             meta: {
            //                 title: '网店管理',
            //                 role: 5,
            //                 parentName: ['studentExamingOnlineShopManagement'],
            //                 hidden: true,
            //             },
            //             children: [
            //                 {
            //                     path: '/student/examing/onlineShopManagement/allOrder',
            //                     name: 'studentExamingOnlineShopManagementsAllOrder',
            //                     component: () => import('../views/student/exam/onlineShopManagement/AllOrder.vue'),
            //                     meta: {
            //                         title: '所有订单',
            //                         tabName: 'studentExamingOnlineShopManagementsAllOrder',
            //                         role: 5,
            //                         parentName: ['studentExamingOnlineShopManagement'],
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopManagement/delivered',
            //                     name: 'studentExamingOnlineShopManagementDelivered',
            //                     component: () => import('../views/student/exam/onlineShopManagement/Delivered.vue'),
            //                     meta: {
            //                         title: '待发货',
            //                         tabName: 'studentExamingOnlineShopManagementDelivered',
            //                         role: 5,
            //                         parentName: ['studentExamingOnlineShopManagement'],
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopManagement/deliverGoods',
            //                     name: 'studentExamingOnlineShopManagementDeliverGoods',
            //                     component: () => import('../views/student/exam/onlineShopManagement/DeliverGoods.vue'),
            //                     meta: {
            //                         title: '已发货',
            //                         tabName: 'studentExamingOnlineShopManagementDeliverGoods',
            //                         role: 5,
            //                         parentName: ['studentExamingOnlineShopManagement'],
            //                     },
            //                 },
            //                 {
            //                     path: '/student/examing/onlineShopManagement/salesOrder',
            //                     name: 'studentExamingOnlineShopManagementSalesOrder',
            //                     component: () => import('../views/student/exam/onlineShopManagement/SalesOrder.vue'),
            //                     meta: {
            //                         title: '售后订单',
            //                         tabName: 'studentExamingOnlineShopManagementSalesOrder',
            //                         role: 5,
            //                         parentName: ['studentExamingOnlineShopManagement'],
            //                     },
            //                 },
            //             ]
            //         }
            //
            //     ]
            // },
            // {
            //     path: '/student/examing/webPromotion',
            //     name: 'studentExamingWebPromotion',
            //     redirect: '/student/examing/webPromotion/index',
            //     component: Main,
            //     meta: {
            //         title: '网络推广',
            //         role: 5
            //     },
            //     children: [
            //         {
            //             path: '/student/examing/webPromotion/index',
            //             name: 'studentExamingOnlineWebPromotionIndex',
            //             component: () => import('../views/student/exam/webPromotion/Index.vue'),
            //             meta: {
            //                 title: '网络推广',
            //                 role: 5,
            //                 parentName: ['studentExamingWebPromotion'],
            //             },
            //         }
            //     ]
            // },
            {
                path: '/student/examing/onlineShopCustomerService',
                name: 'studentExamingOnlineShopCustomerService',
                redirect: '/student/examing/onlineShopCustomerService/index',
                component: Main,
                meta: {
                    title: '网店客户服务',
                    icon: '&#xe686;',
                    role: 5
                },
                children: [
                    {
                        path: '/student/examing/onlineShopCustomerService/index',
                        name: 'studentExamingOnlineShopCustomerServiceIndex',
                        component: () => import('../views/student/exam/onlineShopCustomerService/Index.vue'),
                        meta: {
                            title: '网店客户服务',
                            role: 5,
                            parentName: ['studentExamingOnlineShopCustomerService'],
                        },
                    }
                ]
            },
            // {
            //     path: '/student/examing/ECommerceDataCollectionAndCleaning',
            //     name: 'studentExamingECommerceDataCollectionAndCleaning',
            //     redirect: '/student/examing/ECommerceDataCollectionAndCleaning/index',
            //     component: Main,
            //     meta: {
            //         title: '电子商务数据收集与清洗',
            //         role: 5
            //     },
            //     children: [
            //         {
            //             path: '/student/examing/ECommerceDataCollectionAndCleaning/index',
            //             name: 'studentExamingECommerceDataCollectionAndCleaningIndex',
            //             component: () => import('../views/student/exam/ECommerceDataCollectionAndCleaning/Index.vue'),
            //             meta: {
            //                 title: '电子商务数据收集与清洗',
            //                 role: 5,
            //                 parentName: ['studentExamingECommerceDataCollectionAndCleaning'],
            //             },
            //         }
            //     ]
            // },
        ]
    }
]

const createRouter = () => new VueRouter({
    scrollBehavior: () => ({y: 0}),
    base: process.env.BASE_URL,
    // routes: LoginRoutes.concat(adminRoutes)
    routes: adminRoutes.concat(schoolRoutes).concat(teacherRoutes).concat(judgesRoutes).concat(studentRoutes).concat(LoginRoutes)
})

const router = createRouter()

// const router = new VueRouter({
//   routes
// })

export default router
